import { Box, type BoxProps } from '@chakra-ui/react';
import type { FC, ReactNode } from 'react';

interface SubtitleProps extends BoxProps {
  children: ReactNode;
}

const Subtitle: FC<SubtitleProps> = ({ children, ...boxProps }) => {
  return (
    <Box textAlign="center" textWrap="balance" textStyle="body2" {...boxProps}>
      {children}
    </Box>
  );
};

export default Subtitle;
